import { render, staticRenderFns } from "./PressPage.vue?vue&type=template&id=775d2496&scoped=true"
import script from "./PressPage.vue?vue&type=script&lang=js"
export * from "./PressPage.vue?vue&type=script&lang=js"
import style0 from "./PressPage.vue?vue&type=style&index=0&id=775d2496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775d2496",
  null
  
)

export default component.exports